import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-form-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "price-info" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "price-label" }, "该模块可突破专供标签限制，直接允许非对应标签客户下专供商品，请谨慎申请")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}